// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #333;
  color: white;
  padding: 5px 10px;
  border-radius: 0 0 5px 5px;
}

.control-left, .control-right {
  display: flex;
  align-items: center;
}

.past-dropdown {
  position: relative;
  margin: 0 10px;
}

.past-btn {
  display: flex;
  align-items: center;
}

.icon-dropdown {
  margin-left: 5px;
}

.timeline-controls {
  display: flex;
  align-items: center;
}

.control-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  padding: 5px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.control-btn:hover {
  color: #fff;
}

.control-btn .icon {
  width: 20px;
  height: 20px;
}

.timeline-container {
  flex: 1;
  margin: 0 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.time-slider {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  outline: none;
}

.time-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  margin-top: 0px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.time-slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  border: none;
  transform: translateY(-50%);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.time-slider::-moz-range-track {
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 2px;
}

.time-slider::-moz-range-progress {
  background: #fff;
  height: 4px;
  border-radius: 2px;
}

.time-display {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  white-space: nowrap;
}

.frame-info {
  color: rgba(255, 255, 255, 0.6);
}

.timestamp {
  min-width: 80px;
  text-align: right;
}

.radar-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px 15px;
  border-radius: 4px;
  z-index: 1000;
}

.radar-error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 15px 20px;
  border-radius: 4px;
  text-align: center;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.error-message {
  font-size: 14px;
  font-weight: 500;
}

.retry-btn {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 5px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: background-color 0.2s;
}

.retry-btn:hover {
  background-color: #2980b9;
}

.weather-map {
  position: relative;
  width: 100%;
  height: 100%;
}

.map-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px 15px;
  border-radius: 4px;
  z-index: 1000;
}

.map-tab {
  position: relative;
  height: 500px;
  width: 100%;
}

.timestamp-display {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  z-index: 1000;
  pointer-events: none;
}

/* Remove the old radar-key styles since we now use MapLayerToolbar */
.radar-key {
  display: none;
}

.radar-key-scale {
  display: none;
}

.radar-key-labels {
  display: none;
}

/* Zoom control styling */
.leaflet-control-zoom {
  margin-top: 10vh !important;
}

.leaflet-control-zoom-in,
.leaflet-control-zoom-out {
  background-color: rgba(0, 0, 0, 0.7) !important;
  color: white !important;
  border: none !important;
  width: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
  font-size: 20px !important;
  font-weight: bold !important;
  margin: 5px;
}

.leaflet-control-zoom-in:hover,
.leaflet-control-zoom-out:hover {
  background-color: rgba(0, 0, 0, 0.9) !important;
}

/* Remove default Leaflet borders */
.leaflet-touch .leaflet-control-layers,
.leaflet-touch .leaflet-bar {
  border: none !important;
  background-clip: padding-box;
}

.leaflet-bar {
  box-shadow: none !important;
}

/* Add styles for the animation loading message */
.map-loading.animation-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  z-index: 1001; /* Ensure it's above map layers but potentially below modals */
  font-size: 1.1em;
  text-align: center;
} `, "",{"version":3,"sources":["webpack://./src/components/WeatherMap.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA,qEAAqE;AACrE;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,+CAA+C;EAC/C,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA,mCAAmC;AACnC;;EAEE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa,EAAE,8DAA8D;EAC7E,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".bottom-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #333;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 0 0 5px 5px;\n}\n\n.control-left, .control-right {\n  display: flex;\n  align-items: center;\n}\n\n.past-dropdown {\n  position: relative;\n  margin: 0 10px;\n}\n\n.past-btn {\n  display: flex;\n  align-items: center;\n}\n\n.icon-dropdown {\n  margin-left: 5px;\n}\n\n.timeline-controls {\n  display: flex;\n  align-items: center;\n}\n\n.control-btn {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.8);\n  padding: 5px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.control-btn:hover {\n  color: #fff;\n}\n\n.control-btn .icon {\n  width: 20px;\n  height: 20px;\n}\n\n.timeline-container {\n  flex: 1;\n  margin: 0 15px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.time-slider {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 2px;\n  outline: none;\n}\n\n.time-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #fff;\n  cursor: pointer;\n  margin-top: 0px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.time-slider::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #fff;\n  cursor: pointer;\n  border: none;\n  transform: translateY(-50%);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.time-slider::-moz-range-track {\n  width: 100%;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  border-radius: 2px;\n}\n\n.time-slider::-moz-range-progress {\n  background: #fff;\n  height: 4px;\n  border-radius: 2px;\n}\n\n.time-display {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.frame-info {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.timestamp {\n  min-width: 80px;\n  text-align: right;\n}\n\n.radar-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  padding: 10px 15px;\n  border-radius: 4px;\n  z-index: 1000;\n}\n\n.radar-error {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: rgba(0, 0, 0, 0.7);\n  color: white;\n  padding: 15px 20px;\n  border-radius: 4px;\n  text-align: center;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.error-message {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.retry-btn {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 5px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: background-color 0.2s;\n}\n\n.retry-btn:hover {\n  background-color: #2980b9;\n}\n\n.weather-map {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.map-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  padding: 10px 15px;\n  border-radius: 4px;\n  z-index: 1000;\n}\n\n.map-tab {\n  position: relative;\n  height: 500px;\n  width: 100%;\n}\n\n.timestamp-display {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background-color: rgba(0, 0, 0, 0.6);\n  color: white;\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  z-index: 1000;\n  pointer-events: none;\n}\n\n/* Remove the old radar-key styles since we now use MapLayerToolbar */\n.radar-key {\n  display: none;\n}\n\n.radar-key-scale {\n  display: none;\n}\n\n.radar-key-labels {\n  display: none;\n}\n\n/* Zoom control styling */\n.leaflet-control-zoom {\n  margin-top: 10vh !important;\n}\n\n.leaflet-control-zoom-in,\n.leaflet-control-zoom-out {\n  background-color: rgba(0, 0, 0, 0.7) !important;\n  color: white !important;\n  border: none !important;\n  width: 40px !important;\n  height: 40px !important;\n  line-height: 40px !important;\n  font-size: 20px !important;\n  font-weight: bold !important;\n  margin: 5px;\n}\n\n.leaflet-control-zoom-in:hover,\n.leaflet-control-zoom-out:hover {\n  background-color: rgba(0, 0, 0, 0.9) !important;\n}\n\n/* Remove default Leaflet borders */\n.leaflet-touch .leaflet-control-layers,\n.leaflet-touch .leaflet-bar {\n  border: none !important;\n  background-clip: padding-box;\n}\n\n.leaflet-bar {\n  box-shadow: none !important;\n}\n\n/* Add styles for the animation loading message */\n.map-loading.animation-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: rgba(0, 0, 0, 0.7);\n  color: white;\n  padding: 10px 20px;\n  border-radius: 5px;\n  z-index: 1001; /* Ensure it's above map layers but potentially below modals */\n  font-size: 1.1em;\n  text-align: center;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
